import { render, staticRenderFns } from "./ReplaceMobile.vue?vue&type=template&id=6d3cbfc2&scoped=true&"
import script from "./ReplaceMobile.vue?vue&type=script&lang=js&"
export * from "./ReplaceMobile.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceMobile.vue?vue&type=style&index=0&id=6d3cbfc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3cbfc2",
  null
  
)

export default component.exports